module.exports = __webpack_public_path__ + "img/SEGURIFY_landing_icono_002_compara.fa0e6f8c.png";